import axiosInstance from '../api/axiosInstance';
import { Category } from '../types';

let categoryCache: Category[] | null = null;

// 특정 카테고리의 상위 경로를 가져오는 함수
export const getCategoryPath = (categoryId: number, categories: any[]): string => {
  const category = categories.find(c => c.id === categoryId);
  if (!category) return '';

  const path: string[] = [category.name];
  let currentCategory = category;

  while (currentCategory.parent_id) {
    const parent = categories.find(c => c.id === currentCategory.parent_id);
    if (!parent) break;
    path.unshift(parent.name);
    currentCategory = parent;
  }

  return path.join(' > ');
};

export const buildCategoryHierarchy = async (): Promise<Category[]> => {
  if (categoryCache) {
    return categoryCache;
  }

  try {
    const response = await axiosInstance.get('/api/categories');
    const categories = response.data;

    // 각 카테고리의 전체 경로를 생성
    const categoriesWithPath = categories.map((category: any) => ({
      ...category,
      displayName: getCategoryPath(category.id, categories)
    }));

    // 캐시에 저장
    categoryCache = categoriesWithPath;
    return categoriesWithPath;
  } catch (error) {
    console.error('카테고리 로딩 실패:', error);
    return [];
  }
}; 